module.exports = __webpack_public_path__ + "media/components/assets/icons/naver_symbol_logo-c117afa9f02996db37d740ee5bcddee4.svg";